import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
const sellingPoints = [{
  emoji: '🎂',
  title: 'Cumpleaños infantiles',
  description: 'Candy bar temáticos que se venden solos',
  color: 'from-pink-500/20 to-pink-600/10',
  border: 'border-pink-400/30',
  iconBg: 'bg-pink-500',
  image: 'https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=400&h=300&fit=crop'
}, {
  emoji: '🎉',
  title: 'Fiestas de 15',
  description: 'Eventos con alto consumo y ticket elevado',
  color: 'from-purple-500/20 to-purple-600/10',
  border: 'border-purple-400/30',
  iconBg: 'bg-purple-500',
  image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=400&h=300&fit=crop'
}, {
  emoji: '💍',
  title: 'Casamientos',
  description: 'Mesas dulces premium con gran margen',
  color: 'from-palomitas-gold/20 to-yellow-600/10',
  border: 'border-palomitas-gold/30',
  iconBg: 'bg-palomitas-gold',
  image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=400&h=300&fit=crop'
}, {
  emoji: '🍼',
  title: 'Baby showers',
  description: 'Pedidos personalizados y recurrentes',
  color: 'from-sky-500/20 to-sky-600/10',
  border: 'border-sky-400/30',
  iconBg: 'bg-sky-500',
  image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=400&h=300&fit=crop'
}, {
  emoji: '🎈',
  title: 'Bautismos y comuniones',
  description: 'Eventos familiares con alta demanda',
  color: 'from-teal-500/20 to-teal-600/10',
  border: 'border-teal-400/30',
  iconBg: 'bg-teal-500',
  image: 'https://images.unsplash.com/photo-1464349153159-4b3e8e2e4068?w=400&h=300&fit=crop'
}, {
  emoji: '🏢',
  title: 'Eventos corporativos',
  description: 'Regalos empresariales y ventas por volumen',
  color: 'from-slate-500/20 to-slate-600/10',
  border: 'border-slate-400/30',
  iconBg: 'bg-slate-600',
  image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=400&h=300&fit=crop'
}, {
  emoji: '🎓',
  title: 'Egresos',
  description: 'Fiestas con consumo masivo',
  color: 'from-indigo-500/20 to-indigo-600/10',
  border: 'border-indigo-400/30',
  iconBg: 'bg-indigo-500',
  image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=400&h=300&fit=crop'
}, {
  emoji: '🏫',
  title: 'Kioscos escolares',
  description: 'Venta diaria y constante',
  color: 'from-emerald-500/20 to-emerald-600/10',
  border: 'border-emerald-400/30',
  iconBg: 'bg-emerald-500',
  image: 'https://images.unsplash.com/photo-1582793988951-9aed5509eb97?w=400&h=300&fit=crop'
}, {
  emoji: '🎁',
  title: 'Regalos personalizados',
  description: 'Fechas especiales y pedidos únicos',
  color: 'from-rose-500/20 to-rose-600/10',
  border: 'border-rose-400/30',
  iconBg: 'bg-rose-500',
  image: 'https://images.unsplash.com/photo-1549465220-1a8b9238f7e7?w=400&h=300&fit=crop'
}, {
  emoji: '🎄',
  title: 'Fechas clave',
  description: 'Navidad, Día del Niño, Mundial y temporadas altas',
  color: 'from-red-500/20 to-orange-600/10',
  border: 'border-red-400/30',
  iconBg: 'bg-red-500',
  image: 'https://images.unsplash.com/photo-1512389142860-9c449e58a814?w=400&h=300&fit=crop'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function SellingPoints() {
  return <section className="py-20 bg-gradient-to-b from-palomitas-dark via-[#2a1f18] to-palomitas-dark relative overflow-hidden" data-id="element-238">
      {/* Decorative blobs */}
      <div className="absolute top-10 left-[-5%] w-80 h-80 bg-palomitas-coral/10 rounded-full blur-3xl" data-id="element-239" />
      <div className="absolute bottom-10 right-[-5%] w-80 h-80 bg-palomitas-gold/10 rounded-full blur-3xl" data-id="element-240" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-241">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-242">
          <span className="inline-block bg-palomitas-gold/20 text-palomitas-gold px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-5 border border-palomitas-gold/30" data-id="element-243">
            🍿 Oportunidades de venta
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-244">
            ¿Dónde podés vender{' '}
            <span className="text-palomitas-gold" data-id="element-245">Palomitas Gourmet</span>?
          </h2>
          <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto" data-id="element-246">
            Convertí cualquier evento en una oportunidad de ingreso
          </p>
        </motion.div>

        {/* Cards Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-id="element-247">
          {sellingPoints.map((point, index) => <motion.div key={index} variants={cardVariants} whileHover={{
          y: -6,
          scale: 1.03
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20
        }} className={`group relative bg-gradient-to-br ${point.color} backdrop-blur-sm rounded-2xl overflow-hidden border ${point.border} cursor-default`} data-id="element-248">
              {/* Image */}
              <div className="relative h-28 md:h-32 overflow-hidden" data-id="element-249">
                <img src={point.image} alt={point.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-250" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-251" />
                {/* Emoji badge */}
                <div className={`absolute top-2 right-2 w-9 h-9 ${point.iconBg} rounded-lg flex items-center justify-center text-lg shadow-lg`} data-id="element-252">
                  {point.emoji}
                </div>
              </div>
              {/* Text */}
              <div className="p-3 md:p-4" data-id="element-253">
                <h3 className="text-white font-bold text-sm md:text-base text-center mb-1 leading-tight" data-id="element-254">
                  {point.title}
                </h3>
                <p className="text-white/60 text-xs md:text-sm text-center leading-snug" data-id="element-255">
                  {point.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Bottom highlight block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-14 text-center" data-id="element-256">
          <div className="inline-block bg-gradient-to-r from-palomitas-gold/20 via-palomitas-gold/10 to-palomitas-gold/20 border border-palomitas-gold/30 rounded-2xl px-8 py-6 mb-8" data-id="element-257">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-258">
              💰 Un solo producto,{' '}
              <span className="text-palomitas-gold" data-id="element-259">múltiples formas</span> de
              generar ingresos
            </p>
          </div>

          <div className="flex justify-center" data-id="element-260">
            <Button href="#oferta" className="text-lg md:text-xl px-10 py-5 !bg-green-600 hover:!bg-green-700 !text-white shadow-2xl shadow-green-900/30 font-bold uppercase tracking-wide" data-id="element-261">
              🚀 QUIERO EMPEZAR AHORA
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}